export const ERRORS_SLICE_NAME = "errors"
